var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteLogsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.575,
    height: 13.972,
    viewBox: "0 0 12.575 13.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete",
    d: "M14.891,5.148H3.714V15.224a.725.725,0,0,0,.7.748h9.78a.725.725,0,0,0,.7-.748V5.148ZM10.874,6.89a.524.524,0,0,1,.524.524v5.938a.524.524,0,0,1-1.048,0V7.414A.524.524,0,0,1,10.874,6.89Zm-3.144,0a.524.524,0,0,1,.524.524v5.938a.524.524,0,1,1-1.048,0V7.414A.524.524,0,0,1,7.731,6.89ZM7.207,3.4V2.7a.719.719,0,0,1,.7-.7H10.7a.719.719,0,0,1,.7.7v.7h3.67a.522.522,0,0,1,0,1.044H3.537a.522.522,0,1,1,0-1.044Zm3.144,0V3.048h-2.1V3.4Z",
    transform: "translate(-3.015 -2)",
    fill: "#6d7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLogsIcon);
export default __webpack_public_path__ + "static/media/delete_logs_icon.2f5007969107aefad004a04627bd8466.svg";
export { ForwardRef as ReactComponent };